require('../es');
require('../web');
var path = require('../internals/path');

module.exports = path;



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/stable/index.js
// module id = nj15
// module chunks = 04af